import React, { useEffect } from 'react';
import { SeoBar } from '../components/SeoBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from './spinner-multi-turret-turning/HeroSection';
import { SpecsSection } from './spinner-multi-turret-turning/SpecsSection';
import { MachineModelsSection } from './spinner-multi-turret-turning/MachineModelsSection';
export function SpinnerMultiTurretTurningPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-3989">
      <SeoBar data-id="element-3990" />
      <Header data-id="element-3991" />
      <main className="flex-grow" data-id="element-3992">
        <div className="w-full bg-white pb-20" data-id="element-3993">
          <HeroSection data-id="element-3994" />
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-3995">
            <SpecsSection data-id="element-3996" />
            <MachineModelsSection data-id="element-3997" />
          </div>
        </div>
      </main>
      <Footer data-id="element-3998" />
    </div>;
}